/**
 * components/tableElements/TableHeader.jsx
 */

import { useCrudList } from "../../context/CrudContext";

export default function TableHeader() {
    const { state, actions } = useCrudList();
    const allSelected =
        state.items.length > 0 && state.selected.length === state.items.length;
    const someSelected =
        state.selected.length > 0 && state.selected.length < state.items.length;

    return (
        <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
                <th className="px-4 sm:px-6 py-3 text-start">
                    <input
                        type="checkbox"
                        checked={allSelected}
                        ref={(el) => {
                            if (el) el.indeterminate = someSelected;
                        }}
                        onChange={() => actions.selectAll()}
                        disabled={state.items.length === 0}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                </th>
                <th className="px-3 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">
                    ID
                </th>
                <th className="px-3 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">
                    Title
                </th>
                <th className="px-3 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">
                    Status
                </th>
                <th className="px-3 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">
                    Applies To
                </th>
                <th className="px-3 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">
                    Date Created
                </th>
                <th className="px-3 py-3 w-10" />
            </tr>
        </thead>
    );
}
